<template>
    <b-modal ref="modal" centered no-close-on-backdrop no-close-on-esc hide-header hide-footer>
        <div class="modal-header">
            <div class="modal-title">
                <h5>{{$t('JOBFORM')}}</h5>
            </div>
            <button type="button" aria-label="Close" @click="close()" class="close"><img src="../../../assets/img/icon-close.svg"></button>
        </div>
        <div class="d-block mt-2 modal-content-inside">
          <div role="group" class="b-form-group form-group" v-if="formData != null">
              <div class="form-row">
                <div class="col-sm-12">
                  <b-form-fieldset v-bind:label="$t('COMPANYWORKER')">
                    <inputvalidation :formerror="formError" name="companyWorkerId">
                        <lbselect 
                          :empty="true" 
                          :list="companyWorker.root" 
                          :total-count="companyWorker.totalCount"
                          :pagination="companyWorkerPagination"
                          v-on:reload="getUsers()"
                          v-model="formData.companyWorkerId" 
                          value-field="userId" 
                          :display-func="(item) => getCompaynWorkerName(item)">>
                        </lbselect>
                    </inputvalidation>
                  </b-form-fieldset>
                </div>
              </div>
              <div class="form-row">
                <div class="col-sm-12">
                    <b-form-fieldset v-bind:label="$t('DATE')">
                        <inputvalidation :formerror="formError" name="jobDate">                            
                            <datetimepicker
                                type="datetime"
                                v-model="formData.jobDate"
                                format="YYYY-MM-DD HH:mm:ss"
                                display-format="DD.MM.YYYY. HH:mm"
                                :showSeconds="false"
                                :isUTC="true"
                                :simple="true"
                                :translate-method="trans">
                            </datetimepicker>
                        </inputvalidation>
                    </b-form-fieldset>
                </div>
            </div>
          </div>

          <div class="text-center mt-lg">
              <b-btn class="mr-2 btn-bis btn-cancel" @click="close()">{{$t('CANCEL')}}</b-btn>
              <b-btn class="btn-bis btn-primary" @click="submitData(formData)">{{$t('SAVE')}}</b-btn>
          </div>

          </div>
    </b-modal>
</template>

<script>
import
{
    mapGetters,
}
    from 'vuex';    
import Api from '@/api/job/Job.js';
import SubcompanyApi from '@/api/admin/UserSubCompanies'
import FlowApi from '@/api/flow/FlowOperatorObligations.js';
import BuildingDetailApi from '@/api/building_detail/BuildingDetail.js';
import UserApi from '@/api/admin/Users'
import localTranslate from '../../helpers/local_trans';


export default
{
    name: 'FormAssign',
    props: ['value'],
    data()
    {
        const me = this;

        return {
            companyWorker: {},
            formError: {},
            formData: null,
            companyWorkerPagination: {
                query: '',
                currentPage: 1,
                initialId: [],
                limit: 25,
                searchTimeout: false,
            },
        };
    },
    methods:
    {
        trans(key)
        {
            const me = this;
            return localTranslate(me.globals.langId, key);
        },
        getCompaynWorkerName(item)
        {
            let str = `${item.name} ${item.surname}`;
            return str;
        },
        async submitData(item)
        {
            const me = this;
            try
            {
                if (typeof item.jobId !== 'undefined')
                {
                    item.id = item.jobId;
                    delete (item.jobId);
                }

                const data = await Api.assignJob(item);
                me.$notify.notice(data);

                if (data.error)
                {
                    me.formError = data;
                }
                else
                {
                    me.close();
                }
            }
            catch (e)
            {
              console.log(e);
                me.$notify.notice(e);
            }
        },
        async getUsers()
        {
            const me = this;
            try
            {
                const data = await UserApi.selectRow(me.getCompanyWorkerParams);
                if (data.error && data.error === true)
                {
                    throw (data);
                }

                for(var i=0;i<data.root.length;i++)
                {
                    data.root[i].password = '';
                    data.root[i].trhidden = false;
                }

                me.companyWorker = data;
            }
            catch (error)
            {
                me.$notify.notice(error);
            }
        },
        close()
        {
            const me = this;
            me.formData = null;
            me.formError = {};
            me.showPeriod = 0;
            me.$emit('close');
        },
    },
    watch:
    {
        async formData(val)
        {
            const me = this;
            if (val != null)
            {
                await me.getUsers();
                me.$refs.modal.show();
            }
            else
            {
                me.$refs.modal.hide();
            }
        },
        value(val)
        {
            const me = this;
            if (val != null)
            {
                me.formData = { ...val };
            }
            else
            {
                me.formData = null;
            }
        },
    },
    computed:
    {
        ...mapGetters([
            'globals',
        ]),
      getCompanyWorkerParams()
      {
          const me = this;
          const data = { ...me.companyWorkerPagination };
          data.start = (data.currentPage - 1) * data.limit;
          data.getWorkers = true;
          return data;
      },
    },
};
</script>
